var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SpaceOpener',[_c('FileManager',{attrs:{"show_add_menu":"true","title":"我的网盘","space":_vm.space}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }